import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Games from '../../views/MainPage/MainPage';
import { getUser } from '../../redux/selectors';
import { connect } from 'react-redux';
import ProductCard from '../../views/ProductCard/ProductCard';
import Profile from '../../views/Profile/Profile';
import Cart from '../../views/Cart/Cart';
import Checkout from '../../views/Checkout/Checkout';
import PaymentInStore from '../../views/PaymentInStore/PaymentInStore';
import ResetPassword from '../../views/ResetPassword/ResetPassword';
import PaymentResult from '../../views/PaymentResult/PaymentResult';

export const ROUTES = Object.freeze({
  MAIN: '/',
  RESET_PASSWORD: '/reset-password',
  PRODUCT_CARD: '/items',
  PROFILE: '/profile',
  CART: '/cart',
  CHECKOUT: '/checkout',
  PAYMENT_IN_STORE: '/payment-in-store',
  CARD_PAYMENT_RESULT: '/card-payment-result',
  BANK_PAYMENT_RESULT: '/bank-payment',
  APP_REDIRECT: '/app'
});

const authorizedRoutes = Object.freeze([
  { path: ROUTES.PROFILE, element: <Profile /> },
  { path: ROUTES.CHECKOUT, element: <Checkout /> },
  { path: ROUTES.PAYMENT_IN_STORE, element: <PaymentInStore /> },
  { path: ROUTES.CARD_PAYMENT_RESULT, element: <PaymentResult /> },
  { path: ROUTES.BANK_PAYMENT_RESULT, element: <PaymentResult /> }
]);

const unauthorizedRoutes = Object.freeze([
  { path: ROUTES.RESET_PASSWORD, element: <ResetPassword /> },
  { path: ROUTES.MAIN, element: <Games /> },
  { path: ROUTES.PRODUCT_CARD, element: <ProductCard /> },
  { path: ROUTES.CART, element: <Cart /> },
  { path: ROUTES.CARD_PAYMENT_RESULT, element: <PaymentResult /> },
  { path: ROUTES.BANK_PAYMENT_RESULT, element: <PaymentResult /> }
]);

const AppRouter = ({ userId }) => {
  return (
    <Routes>
      {Boolean(userId) ? (
        <React.Fragment>
          {[...authorizedRoutes, ...unauthorizedRoutes].map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
              exact
            />
          ))}
          <Route path='*' element={<Navigate to={ROUTES.MAIN} />} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {unauthorizedRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
              exact
            />
          ))}
          <Route path='*' element={<Navigate to={ROUTES.MAIN} />} />
        </React.Fragment>
      )}
    </Routes>
  );
};

const mapStateToProps = (state) => ({
  userId: getUser(state).id
});

export default connect(mapStateToProps)(AppRouter);
